const items = [
  "Licensed & Insured",
  "RN-Supervised Care",
  "Serving Families Across New Jersey",
  "Compassionate, Background-Checked Caregivers",
  "Personalized Care Plans",
  "Available 24/7",
];

const Row = ({ hidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((item, i) => (
      <div key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-lg italic text-charcoal-light sm:text-xl">
          {item}
        </span>
        <span className="block h-2 w-2 rotate-45 border border-gold/70 bg-gold/15" />
      </div>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="trust-marquee"
    className="overflow-hidden border-y border-gold/20 bg-white py-5"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;
